import type { ThemeOptions } from '@mui/material';
import { checkboxClasses } from '@mui/material/Checkbox';
import {
  CheckboxCheckedIcon,
  CheckboxIndeterminateIcon,
  CheckboxUncheckedIcon
} from '../../icons/icons';

export const ModMuiCheckbox: ThemeOptions['components']['MuiCheckbox'] = {
  defaultProps: {
    checkedIcon: <CheckboxCheckedIcon />,
    icon: <CheckboxUncheckedIcon />,
    indeterminateIcon: <CheckboxIndeterminateIcon />
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // Only apply Mod styles to non-ModCheckbox instances
      '&:not(.mod-checkbox)': {
        color: theme.palette.text.primary,
        [`&.${checkboxClasses.indeterminate}`]: {
          color: theme.palette.text.primary
        },
        '&.Mui-checked': {
          color: theme.palette.text.primary
        },
        '&.Mui-checked.Mui-disabled': {
          color: theme.palette.text.disabled
        },
        '&.Mui-disabled': {
          color: theme.palette.text.disabled
        }
      }
    })
  }
};
